import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PayloadService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getChiSiamo(): Observable<any> {
    return this.http.get(`${this.apiUrl}/globals/chiSiamo`);
  }

  getMappa(): Observable<any> {
    return this.http.get(`${this.apiUrl}/globals/mappa`);
  }

  getHomePage(): Observable<any> {
    return this.http.get(`${this.apiUrl}/globals/home`);
  }

  getDonazioni(): Observable<any> {
    return this.http.get(`${this.apiUrl}/globals/donazioni`);
  }

  getPosts(): Observable<any> {
    return this.http.get(`${this.apiUrl}/posts`);
  }

  getPostBySlug(slug: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/posts?where[slug][equals]=${slug}`);
  }

  getPage(slug: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/pages?where[slug][equals]=${slug}`);
  }

  // For authenticated calls
  getProtectedData(token: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/protected-endpoint`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  getEventi(): Observable<any> {
    const today = new Date().toISOString();
    return this.http.get(`${this.apiUrl}/eventi?where[dataInizio][greater_than_equal]=${today}&sort=dataInizio&depth=1`);
  }

  getEventoBySlug(slug: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/eventi?where[slug][equals]=${slug}&depth=2`);
  }

  subscribeWorshipRelease(email: string, canzone: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/worship-subscribers`, {
      email,
      canzone,
    });
  }

  generateCoupon(email: string, codiceBuono: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/coupons/generate`, {
      email,
      codiceBuono,
    });
  }
}
